import { icon } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'icon',
  label: 'Icon',
  category: 'Data Display',
  image: icon
};
